import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { isDevMode } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import clarity from '@microsoft/clarity';

async function prepareApp() {
  if (isDevMode() && environment.enableMock) {
    const { worker } = await import('./mock/browser');
    return worker.start();
  }

  return Promise.resolve();
}

function initializeClarity() {
  setTimeout(() => {
    try {
      if (typeof clarity !== 'undefined') {
        clarity.init(environment.clarity.projectId);
      }
    } catch (error) {
      console.error('[Clarity] Failed to initialize:', error);
    }
  }, 100);
}

prepareApp().then(() => {
  // Initialize Clarity before bootstrapping the app
  initializeClarity();

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
});
